import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { formatDateTime } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { Loader2, Mail, Copy, Trash2, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function OutgoingEmails() {
  const [data, setData] = useState(null);

  const load = () => api.get("/outgoing-emails").then(({ data }) => setData(data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  useEffect(() => { load(); }, []); // eslint-disable-line

  const fullUrl = (l) => (l && l.startsWith("http") ? l : `${window.location.origin}${l || ""}`);
  const copy = (text) => { navigator.clipboard.writeText(text); toast.success("Bağlantı kopyalandı."); };
  const clear = async () => { try { await api.delete("/outgoing-emails"); toast.success("Posta kutusu temizlendi."); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Giden E-postalar (Test)</h1>
          <p className="text-sm text-slate-500 mt-1">Test modunda gerçek e-posta gönderilmez. Tüm iletiler ve bağlantılar burada görünür.</p>
        </div>
        {data?.items?.length > 0 && <Button variant="outline" onClick={clear} data-testid="clear-emails-btn"><Trash2 className="h-4 w-4 mr-2" /> Temizle</Button>}
      </div>

      {data && (
        <div className="flex items-center gap-2 text-sm">
          <span className="text-slate-500">E-posta gönderimi:</span>
          <StatusBadge tone={data.email_enabled ? "active" : "passive"}>{data.email_enabled ? "Açık" : "Kapalı (Test)"}</StatusBadge>
        </div>
      )}

      {data === null ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-sky-600" /></div> :
        data.items.length === 0 ? (
          <Card className="border-slate-200 border-dashed"><CardContent className="py-16 text-center text-slate-500">
            <Mail className="h-10 w-10 mx-auto mb-3 text-slate-300" /> Henüz giden ileti yok.
          </CardContent></Card>
        ) : (
          <div className="space-y-3">
            {data.items.map((m) => (
              <Card key={m.id} className="border-slate-200" data-testid={`email-item-${m.id}`}>
                <CardContent className="pt-5">
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                      <div className="font-medium text-slate-800">{m.subject}</div>
                      <div className="text-sm text-slate-500">Alıcı: {m.to}</div>
                      <div className="text-sm text-slate-600 mt-2">{m.body}</div>
                    </div>
                    <div className="flex flex-col items-end gap-1 shrink-0">
                      <StatusBadge tone="info">{m.kind}</StatusBadge>
                      <span className="text-[11px] text-slate-400">{formatDateTime(m.created_at)}</span>
                    </div>
                  </div>
                  {m.link && (
                    <div className="mt-3 flex flex-wrap items-center gap-2 bg-slate-50 border border-slate-200 rounded-lg p-2">
                      <code className="font-mono-tmgd text-xs text-sky-700 truncate flex-1 min-w-0">{fullUrl(m.link)}</code>
                      <Button size="sm" variant="outline" onClick={() => copy(fullUrl(m.link))} data-testid={`email-copy-${m.id}`}><Copy className="h-3.5 w-3.5 mr-1" /> Kopyala</Button>
                      <a href={fullUrl(m.link)} target="_blank" rel="noreferrer"><Button size="sm" variant="outline" data-testid={`email-open-${m.id}`}><ExternalLink className="h-3.5 w-3.5 mr-1" /> Aç</Button></a>
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        )}
    </div>
  );
}
